import { render, staticRenderFns } from "./AddressSelector.vue?vue&type=template&id=17fa2b65&scoped=true&"
import script from "./AddressSelector.vue?vue&type=script&lang=js&"
export * from "./AddressSelector.vue?vue&type=script&lang=js&"
import style0 from "./AddressSelector.vue?vue&type=style&index=0&id=17fa2b65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fa2b65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17fa2b65')) {
      api.createRecord('17fa2b65', component.options)
    } else {
      api.reload('17fa2b65', component.options)
    }
    module.hot.accept("./AddressSelector.vue?vue&type=template&id=17fa2b65&scoped=true&", function () {
      api.rerender('17fa2b65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/components/AddressSelector.vue"
export default component.exports